<template>
  <!-- <div id="mapaOL" -->
  <div ref="map-root"
       style="width: 100%; height: 100%">
  </div>
</template>

<script>
import 'ol/ol.css';
import "ol-layerswitcher/src/ol-layerswitcher.css";
import { Map, View } from 'ol';
import { fromLonLat } from 'ol/proj';
//import { Tile as TileLayer, Group } from 'ol/layer';
import { Tile as TileLayer } from 'ol/layer';
import { OSM, XYZ } from 'ol/source';
//import { LayerSwitcher } from 'ol/control';
import LayerSwitcher from "ol-layerswitcher";

export default {
    name: 'mapaOL',
    props: {
      mapa: Object
    },
    mounted() {
        console.log('***mapaOL', this.mapa);

        this.map = new Map({
            //target: 'mapaOL',
            target: this.$refs['map-root'],
            layers: [
                /* new Group({
                // A layer must have a title to appear in the layerswitcher
                title: 'Base maps',  type: 'base', combine: true, visible: true,
                layers: [ */
                new TileLayer({ title: 'OpenStreet', visible: false, source: new OSM() }),
                new TileLayer({ title: 'GoogleMap',  visible: false, source: new XYZ({url: 'http://mt0.google.com/vt/lyrs=m&hl=es&x={x}&y={y}&z={z}' }) }),
                new TileLayer({ title: 'GoogleSat', visible: true,
                    //source: new OSM()
                    /* source: new XYZ({
                        url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v10/tiles/{z}/{x}/{y}?access_token=My_ACCESS_TOKEN',
                        tileSize: 512
                    }) */
                    source: new XYZ({
                        /* attributions: [
                            'Powered by Esri',
                            'Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community'], */
                        //attributionsCollapsible: false,
                        //url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                        //url: 'http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}',
                        url: 'http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}',
                    })
                })
                ],
                /* })
            ], */
            view: new View({
                //center: [0, 0],
                //zoom: 2
                //center: fromLonLat([0.407352447,40.3838204949172]),
                center: fromLonLat(this.mapa.lonLat),
                zoom: 18,
                maxZoom: 22,
            })
        })

        //layers

        var layerSwitcher = new LayerSwitcher([{
            reverse: false,
            //activationMode: 'click',
            startActive: true,
            groupSelectStyle: 'default' // Can be 'children' [default], 'group' or 'none'
        }]);
        this.map.addControl(layerSwitcher);

        layerSwitcher.showPanel();

        /* this.map.addControls([
            //new MousePosition(),
            //new ScaleLine(),
            new LayerSwitcher(),
            //new Permalink({ anchor: true })
        ]); */
    }
}
</script>